module.exports = __webpack_public_path__ + "media/fx-morning.e9f3dbbc.mp3";